import { logUsage } from 'owa-analytics';
import { AttachmentWellViewState } from 'owa-attachment-well-data';
import onSendMessageSucceeded from 'owa-mail-compose-actions/lib/actions/onSendMessageSucceeded';
import { getStore as getMailComposeStore } from 'owa-mail-compose-store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { trace } from 'owa-trace';
import { orchestrator } from 'satcheljs';
import { messageSuccessfullySent } from '../actions/internalActions';
import {
    didUserForceSendMessage,
    getAttachmentTypeOnValidationFailed,
} from '../selectors/telemetryDataSelectors';
import { ValidatedAttachmentType } from '../store/schema/ValidatedAttachmentType';
import { logPendingPermissionDataPoint } from '../utils/logPendingPermissionDataPoint';
import { logSharingIssueDataPoint } from '../utils/logSharingIssueDataPoint';

// Its 24 unique values but as the length of array could be >= 0 so its 23
const MAX_UNIQUE_CUSTOM_DATA_VALUE = 23;

orchestrator(onSendMessageSucceeded, async actionMessage => {
    const { composeId } = actionMessage;
    const mailComposeStore = getMailComposeStore();
    const attachmentsTypeValidationFailed: ValidatedAttachmentType[] = getAttachmentTypeOnValidationFailed(
        composeId
    );
    const composeViewState = mailComposeStore.viewStates.get(composeId);

    if (attachmentsTypeValidationFailed) {
        for (let i = 0; i < attachmentsTypeValidationFailed.length; i++) {
            if (attachmentsTypeValidationFailed[i] !== undefined) {
                if (composeViewState) {
                    switch (attachmentsTypeValidationFailed[i]) {
                        case ValidatedAttachmentType.ForgottenAttachments:
                            logUsage('ForgottenAttachmentsTriggered', {
                                userAddedAttachments: hasAttachment(
                                    composeViewState.attachmentWell
                                ),
                                docAttachments: Math.min(
                                    MAX_UNIQUE_CUSTOM_DATA_VALUE,
                                    composeViewState.attachmentWell.docViewAttachments.length
                                ),
                                imageAttachments: Math.min(
                                    MAX_UNIQUE_CUSTOM_DATA_VALUE,
                                    composeViewState.attachmentWell.imageViewAttachments.length
                                ),
                                inlineAttachments: Math.min(
                                    MAX_UNIQUE_CUSTOM_DATA_VALUE,
                                    composeViewState.attachmentWell.inlineAttachments.length
                                ),
                                forceSend: didUserForceSendMessage(
                                    composeId,
                                    ValidatedAttachmentType.ForgottenAttachments
                                ),
                                doNotShowAgain: !getUserConfiguration().UserOptions
                                    .CheckForForgottenAttachments,
                            });
                            break;
                        case ValidatedAttachmentType.PendingPermissions:
                            await logPendingPermissionDataPoint(composeId);
                            break;
                        case ValidatedAttachmentType.SharingIssue:
                            await logSharingIssueDataPoint(composeId);
                            break;
                    }
                } else {
                    trace.error(
                        `[AttachmentsTelemetry] No compose view state found for "${composeId}"`
                    );
                }
            }
        }
        messageSuccessfullySent(composeId);
    }
});

function hasAttachment(attachmentWellViewState: AttachmentWellViewState): boolean {
    return (
        attachmentWellViewState.docViewAttachments.length > 0 ||
        attachmentWellViewState.imageViewAttachments.length > 0 ||
        attachmentWellViewState.inlineAttachments.length > 0
    );
}
